var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.033 8.95c-.636 0-1.15-.514-1.15-1.151s.514-1.15 1.15-1.15H6.85V1.831c0-.636.514-1.15 1.15-1.15.638 0 1.151.514 1.151 1.15v4.816h4.816a1.149 1.149 0 01.814 1.964 1.149 1.149 0 01-.814.337H9.15v4.816A1.149 1.149 0 018 14.915c-.637 0-1.15-.513-1.15-1.15V8.95H2.032z",
    fill: "var(--os-colorIconAccent, #235CEE)"
  })));
}
export default SvgPlus;